import { Flex } from "src/components/Flex.tsx";
import { H4 } from "src/components/HeadingV2/HeadingV2.tsx";
import DatabaseViewedThroughLupe from "src/assets/illustrations/database_viewed_through_lupe.svg?react";
import EmptyBox from "src/assets/illustrations/empty_box.svg?react";
import { useTranslation } from "react-i18next";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import { css } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";

export const NoRowsOverlay = ({
  hasFiltersApplied,
}: {
  hasFiltersApplied: boolean;
}) => {
  const { t } = useTranslation(TranslationNamespaceEnum.ExonnHubComponent);
  return (
    <Flex
      css={styles.container}
      flexDirection={"column"}
      justifyContent={"center"}
      alignItems={"center"}
      gap={30}
    >
      {hasFiltersApplied ? (
        <DatabaseViewedThroughLupe css={styles.illustration} />
      ) : (
        <EmptyBox css={styles.illustration} />
      )}
      <H4>
        {hasFiltersApplied
          ? t("noRowsFoundOverlay.title")
          : t("noRowsOverlay.title")}
      </H4>
    </Flex>
  );
};

const styles = {
  container: css({
    height: "100%",
  }),
  illustration: (theme: ExactTheme) =>
    css({
      color: theme.colorsV2.grey[600],
    }),
};
